/* eslint-disable no-confusing-arrow */
const { recommendRandomSort, formatImage, formatUrl } = require('@ifeng/public_method');

module.exports = {
    jsonParse: data => {
        return JSON.parse(data);
    },
    handleAreaAd: data => {
        return data === '0' ? '' : data;
    },
    handleInfoAd: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 145, 80) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleRecommend: data => {
        return data.map(item => ({
            base62Id: item.base62Id,
            url: formatUrl(item.url),
            title: item.title,
            commentUrl: item.commentUrl,
            newsTime: item.newsTime,
        }));
    },
    handlePicAndVideo: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 165, 100) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleNewsList: data => {
        return data.map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 132, 155) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleUnfoldTypeData: data => {
        try {
            return {
                articleUnfold: (data && data.articleUnfold) || '1',
                articleShareUnfold: (data && data.articleShareUnfold) || '1',
                stopReadArticle: (data && data.stopReadArticle) || [],
                videoShareUnfold: (data && data.videoShareUnfold) || '1',
                topicPopup: (data && data.videoShareUnfold) || '1',
                articleShareUnfoldLayer: (data && data.articleShareUnfoldLayer) || {},
                videoShareUnfoldLayer: (data && data.videoShareUnfoldLayer) || {},
                articleUnfoldLayer: (data && data.articleUnfoldLayer) || {},
                topicPopupLayer: (data && data.topicPopupLayer) || {},
                hotNewsBreakLayer: (data && data.hotNewsBreakLayer) || {},
                wxGuideLayer: (data && data.wxGuideLayer) || {},
                browserGuideLayer: (data && data.browserGuideLayer) || {},
                wxLaunch: (data && data.wxLaunch) || {},
                regionFold: (data && data.regionFold) || {},
            };
        } catch (e) {
            console.error(e);
        }
    },
    handleFixedIconData: data => {
        try {
            return {
                image: (data && data.image) || '',
                link: (data && data.link) || '',
                clientLink: (data && data.clientLink) || '',
                topic: (data && data.topic) || '4',
                video: (data && data.video) || '4',
                article: (data && data.article) || '4',
            };
        } catch (e) {
            console.error(e);
        }
    },
    handleGoodbookData: data => {
        return recommendRandomSort(data, 8).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleArticleData: data => {
        return data.slice(0, 3).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleFoVideoData: data => {
        return data.slice(0, 10).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleVideoData: data => {
        return data.slice(0, 3).map(item => ({
            type: 'recommend',
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 100, 56) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleWutonghuiContent: data => {
        return data.slice(0, 2).map(item => ({
            img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 140, 80) : '',
            url: formatUrl(item.url),
            title: item.title,
        }));
    },
    handleSubjectData: data => {
        return data.slice(0, 5).map(
            (item, index) =>
                index === 0
                    ? {
                          img: item.thumbnail && item.thumbnail !== '' ? formatImage(item.thumbnail, 270, 105) : '',
                          url: formatUrl(item.url),
                          title: item.title,
                      }
                    : {
                          url: formatUrl(item.url),
                          title: item.title,
                      },
        );
    },
    handleProductsRecommend: data => {
        return data.slice(0, 5).map((item) => ({
                title: item.title,
                src: (item.thumbnail && formatImage(item.thumbnail, 264, 132)) ||
                    (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0] && item.thumbnails.image[0].url && formatImage(item.thumbnails.image[0].url, 264, 132)) ||
                    '',
                url: formatUrl(item.url),
            })
        );
    },
    handleHitTv1Data: (data) => {
        return data.slice(0, 6).map(item => ({
            title: item.title || '',
            id: item.id || '',
            summary: item.summary || '',
            dataTotal: item?.dataTotal || '',
            tag: item?.tags?.split(',')?.[0] || '',
            thumbnail: item?.miniVideoPoster || item?.posterUrl || item?.thumbnails?.image?.[0].url || ''
        }));
    },
    handleHitTv2Data: (data) => {
        const result = [];

        if (data?.slide_0?.title) {
            for (const key in data) {
                result.push(data[key]);
            }
        }

        return result.map(item => ({
            title: item.title || '',
            id: item.id || '',
            summary: item.summary || '',
            dataTotal: item?.extData?.dataTotal || '',
            tag: item?.extData?.tags?.split(',')?.[0] || '',
            thumbnail: item?.miniVideoPoster || item?.posterUrl || item?.thumbnails?.image?.[0].url || ''
        }));
    },
    handleBigPicSwiperData: (data) => {
        return data.map((item, index) => ({
            id: index,
            url: item.url,
            src: item.thumbnail,
        }));
    },
    handleWutongData: (data) => {
        return data.map((item, index) => ({
            id: item.base62Id || index,
            type: 'doc',
            newstype: 'doc',
            url: item.url,
            title: item.title,
            source: item.source,
            thumbnails: {
                image: [
                    {
                        bytes: 277,
                        url:
                            (item.thumbnails &&
                                item.thumbnails.image &&
                                item.thumbnails.image[0] &&
                                item.thumbnails.image[0].url) ||
                            item.thumbnail ||
                            '',
                    },
                ],
            },
            clickCount: {
                behavior: 'action',
                type: 'click',
                other: {
                    rnum: 0,
                    tag: 't7',
                    kind: 'article',
                    url: item.url && encodeURIComponent(item.url),
                },
            },
        }));
    }
};
